// extracted by mini-css-extract-plugin
module.exports = {"container":"UtilizationGraphLabels_container__E3RNG","label":"UtilizationGraphLabels_label___y47T"};